import { render, staticRenderFns } from "./RewardsView.vue?vue&type=template&id=544ed7b6&"
import script from "./RewardsView.vue?vue&type=script&lang=js&"
export * from "./RewardsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports